import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import DataTable from "../../component/DataTable";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AddOperation from "./AddOperation";
import Editperation from "./EditOperation";

const listEndpoint = ApiEndpoints.operation.List;
const deleteEndpoint = ApiEndpoints.operation.Delete;
const tableHeader = ["Date","Name"];
const tbody = ["createdAt","name"];

const dataFetch = async (setData) => {
  try {
    const response = await ApiRequest("GET", listEndpoint);
    const result = response.departments;
    setData(result);
  } catch (error) {
    console.log(error);
  }
};

export default function Operation() {

  const [data, setData] = useState([]);
  const [locId, setLocId] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modaleditShow, setModalEditShow] = useState(false);

  useEffect(() => {
    dataFetch(setData);
  }, []);

  // const handleDelete = async (location_id) => {
  //   const payload = { location_id };
  //   try {
  //     const response = await ApiRequest("POST", deleteEndpoint, payload);
  //     toast.success(response.message);
  //     dataFetch();
  //   } catch (error) {
  //     console.error("Error deleting author:", error);
  //   }
  // };

  const pagename = {
    name: 'Job Management',
    user: 'Admin',
    innerpage: 'Job Management / Department'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>
  
    <div className="add-btn-section">
      <Link className="admin-add-btn" onClick={() => setModalShow(true)}>Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        setModalShow={setModalEditShow}
        setId = {setLocId}
        // onDelete={handleDelete}
      />
    </div>

    <AddOperation show={modalShow} onHide={() => setModalShow(false)}/>
    <Editperation show={modaleditShow} locId ={locId} onHide={() => setModalEditShow(false)}/>
    </>
  )
}
